// extracted by mini-css-extract-plugin
export default {"title":"AddPost_title__sP4hx","image":"AddPost_image__+X2yS","subj":"AddPost_subj__E4K7e","editor":"AddPost_editor__zJX-u","buttons":"AddPost_buttons__BGkFi"};